export default __webpack_public_path__ + "548f0c5111abb74d6887964ec627a529.svg";